import apiRequester from './apiRequester'

const createApiRequester = apiRequester

export default createApiRequester
